/* eslint-disable no-underscore-dangle */

const Promise = window.Promise || require('promise-polyfill'); // eslint-disable-line global-require
const UIProductItem = require('./productitem');
const UIProductDesc = require('./productsView/productDesc');
const ViewSwitch = require('./productsView/productsViewSwitch');
const API = require('../api');
const LocationService = require('../locationservice');
const LocationStatus = require('../locationstatus');
const domutils = require('../domutils.js');
const Callout = require('./callout.js');
const utils = require('../utils.js');
const listingPageProductsDucks = require('../appState/ducks/listingPageProducts');
const listingPageSetupDucks = require('../appState/ducks/listingPageSetup');
const listingPageHelpers = require('./react/ListingPage/helpers');

// TODO: find proper solution for custom events without jquery

function UIProductListView() {
  let productItem;

  this.__hostElement = document.querySelector('[data-component="list-page-product-list"]');

  if (!this.__hostElement) {
    return;
  }

  this.__channelElements = this.__hostElement.querySelectorAll('.channels-availability');

  const productItems = this.__hostElement.querySelectorAll('article.product');

  this.__viewSwitch = new ViewSwitch();
  this.__productIds = [];
  this.__productItems = {};
  this.__availableProducts = [];
  this.__visibleProductDesc = null;

  for (let i = 0; i < productItems.length; i++) {
    if (productItems[i].id !== '') {
      productItem = new UIProductItem(productItems[i]);
      this.__productIds.push(productItem.getProductId());
      this.__productItems[productItem.getProductId()] = productItem;
      this.__productDesc = new UIProductDesc(
        productItem.__element,
        this.viewProductDesc.bind(this)
      );
    }
  }

  this.initProductsCallout();

  LocationService.changeLocation = this.changeLocation.bind(this);
  LocationService.addEventListener('clearlocation', this.clearAvailability.bind(this), false);
  LocationService.addEventListener('locationstatechange',
    this.onlocationstatechange.bind(this), false);
}

UIProductListView.prototype = {
  /** @type {array<string>} Array of product IDs in this view */
  __productIds: null,

  /** @type {object} UIProductItem object keyed on product IDs for easy look up */
  __productItems: null,

  __bkgFadeoutIntervalHandle: null,

  /** @param {LocationDescriptor} location
      @param {Promise} cancellable
      @returns {Promise} */
  changeLocation: function(location, cancellable) {
    const request = this.checkAvailability(location);
    return Promise.race([request, cancellable]).then(
      (result) => {
        if (result.status === UIProductListView.ProductAvailability.COMPLETE) {
          return Promise.resolve(result);
        }
        return Promise.reject(result);
      },
      (result) => Promise.reject(result)
    );
  },

  isListingRenderedInReact: function() {
    return window.appState.getState().listingPage.pageSetup.renderReactProductList;
  },

  /** @param {string} location */
  /** @returns {Promise} */
  checkAvailability: function setLocation(location) {
    const self = this;

    if (this.isListingRenderedInReact()) {
      window.appState.dispatch(listingPageSetupDucks.setPendingLocationRequest(true));
    } else {
      this.clearAvailability();

      Array.prototype.forEach.call(this.__channelElements, (channel) => {
        channel.classList.add('pending-request');
      });
    }

    return new Promise((resolve, reject) => {
      /** @param {Array<ProductAvailabilityType>} availabilities */
      function onsuccess(availabilities) {
        let productAvailability;
        let productItem;

        // do nothing if the location service has failed somehow
        if (LocationService.getLocationState() === LocationService.LocationState.FAILED) {
          return;
        }

        if (LocationService.getLocationState() === LocationService.LocationState.ERROR) {
          return;
        }

        // data-layer redux action to be dispatched
        const dataLayerAction = { type: 'EVENTS_STOCK_AVAILABILITY', payload: { products: [] } };
        const ddProducts = window.digitalData.products || [];
        const productByFupid = {};

        ddProducts.forEach((value) => {
          if (!productByFupid[value.productID]) {
            productByFupid[value.productID] = value;
          }
        });

        if (self.isListingRenderedInReact()) {
          window.appState.dispatch(listingPageProductsDucks.setProductsPlaceAvailabilities({
            availabilitiesList: availabilities,
            locationPostcode: availabilities[0].__location
          }));
        }

        for (let i = 0; i < availabilities.length; i++) {
          productAvailability = availabilities[i];

          if (!self.isListingRenderedInReact()) {
            productItem = self.__productItems[productAvailability.getProductId()];
            productItem.setAvailability(productAvailability);

            // Store the fact that this product has it's availability set
            // so that we can restore the default with clearAvailability()
            self.__availableProducts.push(productItem);
          }

          // next condition is successful if product is on stock or if is downloadable
          if (productAvailability.isSuccessful() ||
            productAvailability.getProductType() === 'DOWNLOAD') {
            const productID = productAvailability.getProductId().toString();
            const ddProduct = productByFupid[productID] || {
              productID: productID,
              productSKU: null,
              productName: null,
              soonestDelivery: null,
              soonestFreeDelivery: null
            };

            const analytics = productAvailability.getAnalytics();

            // add product info to the redux action's payload
            dataLayerAction.payload.products.push({
              productID: ddProduct.productID,
              productSKU: ddProduct.productSKU,
              productName: ddProduct.productName,
              availabilityStatus:
                `${productAvailability.getDeliveryState()}|` +
                `${productAvailability.getCollectionState()}`,
              soonestDelivery: analytics.soonestDelivery,
              soonestFreeDelivery: analytics.soonestFreeDelivery
            });
          }
        }

        // dispatching of the data-layer redux action
        if (window.appState) {
          window.appState.dispatch(dataLayerAction);
        }

        self.setBkgFadeout(self);

        // Trigger recalculation of height of product items
        if (window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('resize'));
        }

        if (self.isListingRenderedInReact()) {
          window.appState.dispatch(listingPageSetupDucks.setPendingLocationRequest(false));
        }

        Array.prototype.forEach.call(self.__channelElements, (channel) => {
          channel.classList.remove('pending-request');
        });

        resolve(new LocationStatus(LocationService.LocationState.COMPLETE, ''));
      }

      function onerror(error) {
        if (self.isListingRenderedInReact()) {
          window.appState.dispatch(listingPageSetupDucks.setPendingLocationRequest(false));
        }

        Array.prototype.forEach.call(self.__channelElements, (channel) => {
          channel.classList.remove('pending-request');
        });

        // Trigger recalculation of height of product items
        if (window.dispatchEvent) {
          window.dispatchEvent(new CustomEvent('resize'));
        }

        reject(new LocationStatus(
          LocationService.LocationState.ERROR,
          window.App.locale.getFormattedString('component.mcd.postcodechecker.locationerror',
            { location: LocationService.getLocation().location })
        ));
      }

      let productIds;

      if (this.isListingRenderedInReact()) {
        productIds = listingPageHelpers.getCurrentRenderedProductIds();
      } else {
        productIds = self.getSortedProducts().map((item) => item.getProductId());
      }
      API.getProductAvailabilities(productIds, location, onsuccess, onerror);
    });

  },

  /** @returns {void} */
  clearAvailability: function() {
    if (!this.isListingRenderedInReact()) {
      this.resetBkgFadeout();
      for (let i = 0; i < this.__availableProducts.length; i++) {
        this.__availableProducts[i].clearAvailability();
      }
      this.__availableProducts = [];
    }
  },

  onlocationstatechange: function(event) {
    switch (event.detail.status) {
      case LocationService.LocationState.COMPLETE:
        // console.log('ProductListView LocationService.LocationState.COMPLETE');
        this.closeFilter();
        break;
      case LocationService.LocationState.ERROR:
      case LocationService.LocationState.FAILED:
        // console.log('ProductListView LocationService.LocationState.FAILED');
        // reset to default states on error
        this.clearAvailability();
        break;
      default:
        break;
    }
  },

  setBkgFadeout: function(self) {
    if (!self.isListingRenderedInReact()) {
      // Remove the bkg-fadeout class from all channels-availability boxes
      // after 7 seconds (5sec timeout + 2sec fadeout animation)
      // Im setting it here to use one timeout rather than set it separately
      // for each productItem which would result
      // in tens of timeout instances per page. Not wise...
      self.__bkgFadeoutIntervalHandle = setTimeout(() => {
        const productBoxes = self.__hostElement.querySelectorAll('.channels-availability');
        if (productBoxes && productBoxes.length) {
          Array.prototype.forEach.call(productBoxes, (element) => {
            domutils.removeClass(element, 'bkg-fadeout');
          });
        }
      }, 7000);
    }

  },

  resetBkgFadeout: function() {
    if (!this.isListingRenderedInReact()) {
      if (this.__bkgFadeoutIntervalHandle) {
        clearTimeout(this.__bkgFadeoutIntervalHandle);
        this.__bkgFadeoutIntervalHandle = null;
      }
    }
  },

  closeFilter: function() {
    if (window.App.Platform.isDesktop()) {
      return;
    }

    const filterComponent = document.querySelector('[data-component="filtersheader"]');

    if (filterComponent) {
      const toggleControler = filterComponent.querySelector('a.toggleControler.active');

      if (toggleControler) {
        toggleControler.click();
        window.scrollTo(0, 0);
      }
    }
  },

  /** @param {UIProductView.ProductAvailability} update */
  /** @returns {void} */
  onupdateview: function(update) {},

  viewProductDesc: function viewProductDesc(product, desc, show) {
    const wrapper = desc.__descWrapper;
    const badges = desc.__badges;

    if (show) {
      if (this.__visibleProductDesc && this.__visibleProductDesc !== desc) {
        this.__visibleProductDesc.close();
      }
      this.__visibleProductDesc = desc;
      wrapper.style.display = 'block';
      if (badges) {
        badges.className += ' bottom-indent';
      }
    } else {
      wrapper.style.display = 'none';
      if (badges) {
        badges.className = badges.className.replace(/(?:^|\s)bottom-indent(?!\S)/g, '');
      }
    }
  },

  /**
   * Initialize callout in products grid. Callout is for online credit info messages.
   */
  initProductsCallout: function initProductsCallout() {
    const creditCallouts = this.__hostElement.querySelectorAll('.online-credit-message');
    for (let i = 0; i < creditCallouts.length; i++) {
      domutils.on(creditCallouts[i], 'click', this.showCallout);
    }
  },

  /**
   * @param event
   */
  showCallout: function showCallout(event) {
    const calloutHeader = window.App.locale.getString(
      'component.onlinecredit.product-callout-header'
    );
    const calloutText = window.App.locale.getString('component.onlinecredit.product-callout-text');
    let calloutAlignment = Callout.ALIGNMENT_LEFT;
    const responsivityLevel = utils.getResponsivityLevel();

    if (responsivityLevel === 'mobile') {
      return; // Callout is not shown on mobile devices.
    } if (responsivityLevel === 'tablet') {
      calloutAlignment = Callout.ALIGNMENT_TOP;
    }

    event.preventDefault();
    const calloutObj = new Callout(calloutHeader, calloutText, 'Got it', { align: 'left' });
    if (responsivityLevel === 'desktop' || responsivityLevel === 'desktop-wide') {
      calloutObj.minWidth = 300;
    }
    calloutObj.show(event.target, calloutAlignment);
  }
};

UIProductListView.prototype.getSortedProducts = function getSortedProducts() {
  const productsElements = this.__hostElement.querySelectorAll('article.product');
  const products = this.__productItems;

  return Array.from(productsElements)
    .filter((productElement) => {
      const product = new UIProductItem(productElement);
      return product.getProductId() !== '' && products[product.getProductId()];
    })
    .map((productElement) => {
      const product = new UIProductItem(productElement);
      return products[product.getProductId()];
    });
};

UIProductListView.ProductAvailability = {
  DEFAULT: 'none',
  PENDING: 'pending',
  ERROR: 'error',
  COMPLETE: 'complete'
};

module.exports = UIProductListView;
